
/**
 * Created by nijin on 31/1/17.
 */
import { Component, OnInit } from '@angular/core';
import {SchemaService} from '../schema.service';
import {Schema} from '../model/schema.model';
import {Router, ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs/Subscription";
@Component({
  selector: 'nuc-custom-schema',
  templateUrl: './custom-schema.component.html',
  styleUrls: ['./custom-schema.component.scss']
})
export class CustomSchemaComponent implements OnInit {
  customSchemaList: Array<Schema> = [];
  isLoading: boolean = true;
  nameSubscription: Subscription;
  isSearch:boolean;
  searchTerm: string;

  // pagination details
  currentPage = 1;
  pageSize  = 12;
  totalPage;
  maxSize = 3;

  constructor(
    private schemaService: SchemaService,
    private router:Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
     this.nameSubscription = this.route.params.subscribe((params) =>{
       this.searchTerm = params['name'];
       this.currentPage = params['page'] ? params['page'] : 1;
       this.isSearch = !!this.searchTerm;
       this.getCustomSchema({name:this.searchTerm, page: this.currentPage});
    })
  }
  getCustomSchema(params) {
    this.isLoading = true;
    params['page-size'] = this.pageSize;
    this.schemaService.getCustomSchemaList(params)
      .subscribe((response) => {
        this.customSchemaList = response.items;
        this.isLoading = false;
        this.totalPage = response.count;
        },
        ()=>{this.isLoading = false})
  }

  navigateTo() {
    this.router.navigate(['schema/new']);
  }
  pageChange(pageData) {
     this.currentPage = pageData.page;
    const param = {};
    param['page'] = pageData.page;
    if(this.searchTerm) {
      param['name'] = this.searchTerm;
    }
    this.router.navigate(['/schema', param]);
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/schema-list/custom-schema.component.ts